import Vue from 'vue'

const actions = {

    setWidgetProps({ getters }, { id, props = {} } = {}) {
        // const layer
        if (!id) throw new Error('"id" is required')
        const widget = getters.allLayers[id]
        if (!widget) throw new Error('widget is not in layers')
        Object.keys(props).forEach((key) => {
            Vue.set(widget.props, key, props[key])
        })
    },

    setWidgetVisibility({ getters }, { id, show } = {}) {
        // const layer
        if (!id) throw new Error('"id" is required')
        const widget = getters.allLayers[id]
        if (!widget) throw new Error('widget is not in layers')
        const editorStatus = {
            ...widget.editorStatus,
            show
        }
        Vue.set(widget, 'editorStatus', editorStatus)
    }
}

export default actions
